import { Menu } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgNavigationMenu = mkIcon(Menu);